import axios from 'axios'
import { AddEditAdvertRequest as AddEditAdvertRequestApi, AddEditOfferRequest, Configuration, DefaultApi } from '../api'
import { auth } from '../firebase'

// In development, use relative URLs so proxy can intercept
// In production, use the full base URL
const getBaseURL = () => (process.env.NODE_ENV === 'development' ? '' : process.env.REACT_APP_BASE_URL || '')

const configuration = new Configuration({
  basePath: getBaseURL(),
})
axios.defaults.baseURL = getBaseURL()

export const axiosInstance = axios.create({
  baseURL: getBaseURL(),
})

const refreshToken = localStorage.getItem('refreshToken')

const authResponseIntercepter = axiosInstance.interceptors.response.use(
  res => res,
  async error => {
    if (axios.isAxiosError(error) && error.response) {
      if (error.response.status === 401) {
        window.location.replace(`/login`)
        return Promise.reject(error)
      }
      if (error.response.status !== 401) {
        return Promise.reject(error)
      }
      axios.interceptors.response.eject(authResponseIntercepter)
      if (refreshToken && auth.currentUser) {
        auth.currentUser.getIdToken().then(accessToken => {
          localStorage.setItem('accessToken', accessToken)
        })
      }
      return Promise.reject(error)
    }
    return Promise.reject(error)
  }
)

axiosInstance.interceptors.request.use(async config => {
  let token = localStorage.getItem('accessToken')
  const lastTokenRefresh = localStorage.getItem('lastTokenRefresh')
  const now = Date.now()
  const TOKEN_REFRESH_INTERVAL = 30 * 60 * 1000 // 30 minutes

  // Check if we need to refresh the token (every 30 minutes or if no token)
  const shouldRefresh = !token || !lastTokenRefresh || now - parseInt(lastTokenRefresh, 10) > TOKEN_REFRESH_INTERVAL

  if (shouldRefresh && auth.currentUser) {
    try {
      // Force refresh the token to get a new one
      token = await auth.currentUser.getIdToken(true)
      if (token) {
        localStorage.setItem('accessToken', token)
        localStorage.setItem('lastTokenRefresh', now.toString())
        if (process.env.NODE_ENV === 'development') {
          console.log('Token refreshed proactively in axios interceptor')
        }
      }
    } catch (error) {
      console.error('Failed to refresh token in axios interceptor:', error)
    }
  }

  // If no token, try to get a fresh one from Firebase (fallback)
  if (!token && auth.currentUser) {
    try {
      token = await auth.currentUser.getIdToken()
      if (token) {
        localStorage.setItem('accessToken', token)
        localStorage.setItem('lastTokenRefresh', now.toString())
      }
    } catch (error) {
      console.error('Failed to get token from Firebase:', error)
    }
  }

  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`
    // Set tokenInfo header with the token value
    config.headers.tokenInfo = token
  }
  return config
})

const TickleApi = new DefaultApi(configuration, undefined, axiosInstance)

// TODO remove this extension of AddEditAdvertRequest once this change is made in the backend
export interface AddEditAdvertRequest extends Omit<AddEditAdvertRequestApi, 'offers'> {
  offers: AddEditOfferRequest[]
}

export default TickleApi
